import { createAction, props } from '@ngrx/store';

import { EquipmentInstallationsResponse } from '@vi-iot/client';

export namespace InstallationsSearchActions {
  export enum Type {
    LIST_INSTALLATIONS_SEARCH_RESULT = '[INSTALLATIONS SEARCH] List Installations Search Result',
    LIST_INSTALLATIONS_SEARCH_RESULT_SUCCESS = '[INSTALLATIONS SEARCH] List Installations Search Result Success',
    LIST_INSTALLATIONS_SEARCH_RESULT_ERROR = '[INSTALLATIONS SEARCH] List Installations Search Result Error',
    LIST_INSTALLATIONS_SEARCH_FETCH_MORE = '[INSTALLATIONS SEARCH] List Installations Search Fetch More Results',
    LIST_INSTALLATIONS_SEARCH_FETCH_MORE_SUCCESS = '[INSTALLATIONS SEARCH] List Installations Search Fetch More Results Success',
    LIST_INSTALLATIONS_SEARCH_FETCH_MORE_ERROR = '[INSTALLATIONS SEARCH] List Installations Search Fetch More Results Error',
  }

  export const listInstallationsSearchResult = createAction(
    Type.LIST_INSTALLATIONS_SEARCH_RESULT,
    props<{
      gatewaySerial: string;
      boilerSerial: string;
      limit?: number;
      cursor?: string;
    }>()
  );

  export const listInstallationsSearchResultSuccess = createAction(
    Type.LIST_INSTALLATIONS_SEARCH_RESULT_SUCCESS,
    props<{
      payload: EquipmentInstallationsResponse;
    }>()
  );

  export const listInstallationsSearchResultError = createAction(
    Type.LIST_INSTALLATIONS_SEARCH_RESULT_ERROR
  );

  export const listInstallationsSearchFetchMore = createAction(
    Type.LIST_INSTALLATIONS_SEARCH_FETCH_MORE,
    props<{
      gatewaySerial: string;
      boilerSerial: string;
      limit?: number;
      cursor?: string;
    }>()
  );

  export const listInstallationsSearchFetchMoreSuccess = createAction(
    Type.LIST_INSTALLATIONS_SEARCH_FETCH_MORE_SUCCESS,
    props<{
      payload: EquipmentInstallationsResponse;
    }>()
  );

  export const listInstallationsSearchFetchMoreError = createAction(
    Type.LIST_INSTALLATIONS_SEARCH_FETCH_MORE_ERROR
  );
}
